// LIBRARIES
import styled, { css } from "styled-components";

// MISC
import { COLORS, DEVICE_TYPE, MARGIN, SIZE } from "../../constants/variables";

export const HeroCarouselCard = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  background-color: ${COLORS.FaluRed};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    flex-direction: column-reverse;
  }
`;
export const InfoWrapper = styled.div`
  height: 100%;
  width: 30%;
  min-width: 30vw;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: ${SIZE.max120} ${SIZE.max60};
  word-wrap: break-word;
  gap: ${SIZE.max40};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
    padding: ${SIZE.max60};
    height: 55%;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: ${SIZE.max40} ${SIZE.max60};
  }
  @media (max-width: 375px) {
    /* iPhone SE */
    gap: 15px;
  }
  @media (max-height: 650px) {
    gap: 10px;
  }
`;

export const TitleWrapper = styled.div`
display: -webkit-box;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
-webkit-line-clamp: 2;  
font-size: ${SIZE.max60};
line-height: 1.2;
color:${COLORS.AbsoluteWhite};
webkit-text-fill-color: ${COLORS.AbsoluteWhite};
@media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
  -webkit-line-clamp: 3; 
}

@media (max-width: ${DEVICE_TYPE.mobileHeader}) {
  font-size: ${SIZE.max40};
  -webkit-line-clamp: 2;  
}

@media (max-width: 375px) {
  font-size: ${SIZE.max40};
}
`;

export const SubtitleWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${COLORS.Background};
  font-size: ${SIZE.max24};
  line-height: 1.4;
  min-height: calc(${SIZE.max24} * 3.4);
  -webkit-line-clamp: 3;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    -webkit-line-clamp: 4;
    min-height: calc(${SIZE.max24} * 4.4);
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    -webkit-line-clamp: 3;
    font-size: ${SIZE.max18};
    min-height: calc(${SIZE.max18} * 4.4);
  }

  @media (max-width: 1024px) and (max-height: 600px) {
    /* Nest Hub */
    -webkit-line-clamp: 1;
    min-height: calc(${SIZE.max24} * 2);
  }
  @media (max-width: 375px) {
    /* iPhone SE */
    -webkit-line-clamp: 4;
    font-size: ${SIZE.max18};
    min-height: calc(${SIZE.max18} * 5);
  }
`;

export const ImageWrapper = styled.div`
  width: 70%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${COLORS.FaluRed};
  overflow: hidden;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: 45%;
    width: 100%;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  object-position: center;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
    height: 350px;
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    height: 300px;
  }
`;
